module.exports = __webpack_public_path__ + "img/expovina_04.de33e1f5.jpg";